import { QuestionDescription } from "./description";
import { QuestionVoucherName } from "./name";

export const QuestionVoucherI18nBase = () => {
	return (
		<>
			<QuestionVoucherName />
			<QuestionDescription />
		</>
	);
};

QuestionVoucherI18nBase.displayName = "QuestionVoucherI18nBase";
